import type { PropertyValidationResult } from '../../../types/properties';

export default function validator(
  properties: Record<string, any>
): PropertyValidationResult {
  const errors: Array<{ key: string; message: string }> = [];

  // Validate required from email
  if (!properties.from || !properties.from.trim()) {
    errors.push({ key: 'from', message: 'From email address is required' });
  } else if (!isValidEmail(properties.from)) {
    errors.push({ key: 'from', message: 'From must be a valid email address' });
  }

  // Validate required to email
  if (!properties.to || !properties.to.trim()) {
    errors.push({ key: 'to', message: 'To email address is required' });
  } else {
    const toEmails = properties.to.split(',').map((e: string) => e.trim());
    for (const email of toEmails) {
      if (email && !isValidEmail(email)) {
        errors.push({
          key: 'to',
          message: `Invalid email address: ${email}`,
        });
        break;
      }
    }
  }

  // Validate subject
  if (!properties.subject || !properties.subject.trim()) {
    errors.push({ key: 'subject', message: 'Subject is required' });
  }

  // Validate content based on content type
  const contentType = properties.contentType || 'text';
  if (contentType === 'text' || contentType === 'both') {
    if (!properties.textContent || !properties.textContent.trim()) {
      errors.push({
        key: 'textContent',
        message: 'Text content is required for plain text emails',
      });
    }
  }
  if (contentType === 'html' || contentType === 'both') {
    if (!properties.htmlContent || !properties.htmlContent.trim()) {
      errors.push({
        key: 'htmlContent',
        message: 'HTML content is required for HTML emails',
      });
    }
  }

  return {
    valid: errors.length === 0,
    errors,
  };
}

function isValidEmail(email: string): boolean {
  // Basic email validation - allows expressions like {{ $json.email }}
  if (email.includes('{{') && email.includes('}}')) {
    return true;
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email.trim());
}
